import { Instance } from 'mobx-state-tree'
import { ActiveGamesInfoModelBase } from './ActiveGamesInfoModel.base'

/* The TypeScript type of an instance of ActiveGamesInfoModel */
export interface ActiveGamesInfoModelType extends Instance<typeof ActiveGamesInfoModel.Type> {}

/* A graphql query fragment builders for ActiveGamesInfoModel */
export {
  selectFromActiveGamesInfo,
  activeGamesInfoModelPrimitives,
  ActiveGamesInfoModelSelector
} from './ActiveGamesInfoModel.base'

/**
 * ActiveGamesInfoModel
 */
export const ActiveGamesInfoModel = ActiveGamesInfoModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
